<template>
  <div class="app-container-wrapper">
    <head-container>
      <breadcrumb />
    </head-container>
    <div class="app-container no-title">
      <div class="card search">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane label="全部" name="4" /> -->
          <el-tab-pane label="待处理" name="0" />
          <el-tab-pane label="已处理" name="1" />
          <el-tab-pane label="已发起" name="3" />
          <el-tab-pane label="我收到的" name="2" />
        </el-tabs>

        <!--筛选条件-->
        <div class="section">
          <el-form :inline="true" size="small" label-suffix="：">
            <el-form-item v-if="!isDisabled" label="发起人">
              <employee-async-select
                v-model="employeeIdList"
                only-company-employee
                :placeholder="`请选择发起人`"
              />
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input
                v-model.trim="filterForm.orderName"
                placeholder="请输入项目名称"
                clearable
              />
            </el-form-item>
            <el-form-item label="审批类型">
              <el-cascader
                v-model="workflowBusiness"
                :options="workflowBusinessDictList"
              />
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch">
                查询
              </el-button>
              <el-button size="small" @click="handleReset">
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!--表格列表-->
      <div class="card no-padding">
        <jczh-table-content
          :data="tableList"
          :option="tableConfig"
          pagination
          :total="total"
          :page.sync="page"
          :limit.sync="size"
        >
          <!--流程状态-->
          <template v-slot:status="{ row }">
            <el-tag
              :type="
                workflowAuditCheckDict.translate(row.workflowInfo.status).type
              "
            >
              {{
                workflowAuditCheckDict.translate(row.workflowInfo.status).label
              }}
            </el-tag>
          </template>

          <!-- 操作-->
          <template v-slot:operation="{ row }">
            <el-button
              type="text"
              @click="jumpToDetail(row)"
            >
              查看详情
            </el-button>
            <el-button
              v-if="activeName == 3 && row.workflowInfo.status == 1"
              class="m-l-10"
              type="text"
              @click="revoke(row.workflowId)"
            >
              撤销
            </el-button>
          </template>
        </jczh-table-content>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import Breadcrumb from '@/components/common/Breadcrumb/Breadcrumb'
import EmployeeAsyncSelect from '@/components/common/EmployeeAsyncSelect'
import HeadContainer from '@/components/common/HeadContainer'

// 引入数据字典
import {
  workflowAuditCheckDict,
  workflowIdentityDict
} from '@/dictionary/workflow'

// 引入工具函数
import { mapState, mapActions } from 'vuex'

// 后端api
import {
  getWorkflowTodoApi,
  getWorkflowDoneApi,
  getWorkflowReceivedApi,
  getWorkflowLaunchApi,
  auditWorkflowRevekeApi
} from '@/api/workflow'

import listFilterMixin from '@/mixins/list-filter-mixin'

import WujieVue from 'wujie-vue2'

export default {
  name: 'ToDoListAudit',

  components: {
    Breadcrumb,
    EmployeeAsyncSelect,
    HeadContainer
  },

  mixins: [listFilterMixin],

  data() {
    return {
      activeName: '0',
      workflowAuditCheckDict,
      workflowIdentityDict,
      isDisabled: false,

      // 查询表单
      filterForm: {
        initiatorId: '',
        businessType: '',
        businessNode: '',
        orderName: ''
      },
      page: 1,
      size: 10,
      // 表格数据
      total: 0,
      tableList: [],
      tableConfig: [
        {
          label: '审批标题',
          prop: 'workflowInfo',
          filter: value => value.name
        },
        {
          label: '发起人',
          prop: 'workflowInfo',
          filter: value => value?.initiatorInfo?.initiatorName
        },
        {
          label: '项目名称',
          prop: 'orderName'
        },
        {
          label: '审批类型',
          prop: 'workflowInfo',
          filter: value =>
            `${this.workflowBusinessObject[value.businessInfo.businessType]}/${
              this.workflowBusinessObject[value.businessInfo.businessNode]
            }`
        },
        {
          label: '发起时间',
          prop: 'workflowInfo',
          filter: value => value?.timeInfo?.startTime
        },
        {
          label: '完成时间',
          prop: 'workflowInfo',
          filter: value => value?.timeInfo?.endTime || '-'
        },
        { label: '流程状态', slotName: 'status' },
        { label: '操作', slotName: 'operation', width: '150', fixed: 'right' }
      ]
    }
  },

  computed: {
    ...mapState('workflow', ['workflowBusinessList', 'workflowBusinessObject']),

    workflowBusinessDictList() {
      return [
        { label: '全部', value: '' },
        ...(this.workflowBusinessList || [])
      ]
    },

    workflowBusiness: {
      get() {
        const temp = [this.filterForm.businessType]
        this.filterForm.businessNode && temp.push(this.filterForm.businessNode)
        return temp
      },
      set(newVal) {
        this.filterForm.businessType = newVal[0] || ''
        this.filterForm.businessNode = newVal[1] || ''
      }
    },

    employeeIdList: {
      get() {
        return this.filterForm.initiatorId
          ? this.filterForm.initiatorId.split(',').map(v => Number(v))
          : []
      },
      set(val) {
        if (Array.isArray(val)) {
          this.filterForm.initiatorId = val.join(',')
        }
      }
    }
  },

  watch: {
    activeName: {
      handler: function(val) {
        this.filterForm.orderName = ''
      },
      immediate: true
    }
  },

  created() {
    this.getWorkflowBusinessDict()
  },

  activated() {
    this.getList()
  },

  methods: {
    ...mapActions('workflow', ['getWorkflowBusinessDict']),

    handleClick(tab, event) {
      this.page = 1
      this.filterForm.initiatorId = ''
      this.filterForm.businessType = ''
      this.filterForm.businessNode = ''
      if (this.activeName == '3') {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      this.getList()
    },

    /**
     * 获取审批定义列表
     */
    getList() {
      this.epitaxy()
      const params = Object.assign({}, this.filterForm, {
        page: this.page,
        size: this.size
      })
      const apiList = [
        getWorkflowTodoApi,
        getWorkflowDoneApi,
        getWorkflowReceivedApi,
        getWorkflowLaunchApi
      ]
      apiList[this.activeName](params)
        .then(res => {
          if (res?.data?.records.length > 0) {
            if (this.activeName == 3) {
              res.data.records.map(item => {
                item.workflowInfo = {
                  businessInfo: item.businessInfo,
                  initiatorInfo: item.initiatorInfo,
                  timeInfo: item.timeInfo,
                  name: item.name,
                  status: item.status
                }
                item.orderName = item?.orderInfo?.orderName || '-'
              })
            } else {
              res.data.records.map(item => {
                item.orderName = item?.workflowInfo?.orderInfo?.orderName || '-'
              })
            }
          }
          this.tableList = res?.data?.records || []
          this.total = res?.data?.total || 0
        })
        .catch(err => {
          this.tableList = []
          this.total = 0
          this.$message.error(err?.message)
        })
    },
    revoke(workflowId) {
      this.$systemConfirm('确定撤销审批？').then(result => {
        if (!result) return
        auditWorkflowRevekeApi({}, workflowId)
          .then(res => {
            if (res.code == '0') {
              this.$message.success('操作成功')
              this.getList()
            }
          })
          .catch(err => {
            this.$message.error(err?.message)
            this.getList()
          })
      })
    },

    /**
     * 跳转审批详情
     */
    jumpToDetail(row) {
      const params = {
        workflowId: row.workflowId,
        orderId:
            this.activeName == 3
              ? row.orderInfo.orderId
              : row.workflowInfo.orderInfo.orderId,
        taskId: row.taskId ? row.taskId : null,
        identity:
            this.activeName == 3
              ? workflowIdentityDict.INITIATEPERSON.value
              : 'otherIdentity'
      }
      // 五菱审批
      if (row.workflowInfo.businessInfo.businessType === 'wu_ling_bidding_order') {
        this.$router
          .push({
            name: 'WlToDoListAuditDetail'
          })
          .catch(() => {})
        WujieVue.bus.$emit('routerChange', {
          menuName: 'WlToDoListAuditDetail',
          params })
      } else {
        this.$router.push({
          name: 'ToDoListAuditDetail',
          params
        })
      }
    }
  }
}
</script>
